export default __webpack_public_path__ + "static/media/promo-icon-bottom-nav-mobile.5af0f397.webp";